import React, { Suspense } from "react";
import { SectionLoading } from "../Loanding";

/**
 * Envuelve children en <Suspense> con un fallback unificado.
 * Uso:
 *   <RouteLoader>
 *     <Routes>...</Routes>
 *   </RouteLoader>
 *
 * O directamente como wrapper de un lazy component:
 *   <Route path="..." element={<RouteLoader><Lazy /></RouteLoader>} />
 */
export const RouteLoader = ({ children, fallback }) => (
    <Suspense fallback={fallback ?? <SectionLoading />}>
        {children}
    </Suspense>
);

/**
 * Helper para envolver un elemento lazy en Suspense.
 *   lazyElement(<SomeLazy prop={x} />)
 */
export const lazyElement = (element, fallback) => (
    <RouteLoader fallback={fallback}>{element}</RouteLoader>
);
